;(function() {
  'use strict'

  angular.module('app.survey').component('surveyQuestionText', {
    controller: Controller,
    templateUrl: 'survey-question-text.html',
    bindings: {
      survey: '<',
      question: '<',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.getPlaceholder = getPlaceholder
    ctrl.shouldShowMinCharacterWarning = shouldShowMinCharacterWarning

    function onInit() {
      ctrl.prefix = ctrl.survey.injectValues(
        ctrl.question.textPrefixPipes,
        ctrl.question.loopKey
      )
      ctrl.suffix = ctrl.survey.injectValues(
        ctrl.question.textSuffixPipes,
        ctrl.question.loopKey
      )
    }

    function getPlaceholder(index) {
      var placeholder
      if (ctrl.question.textValidator === 'EMAIL') {
        placeholder = ctrl.question.responder.labels.EMAIL_INPUT_PLACEHOLDER
      } else if (
        ctrl.question.textValidator === 'NUMERIC' ||
        ctrl.question.textValidator === 'NUMERIC_RANGE'
      ) {
        placeholder = ctrl.question.responder.labels.NUMBER_INPUT_PLACEHOLDER
      } else {
        placeholder = ctrl.question.responder.labels.TEXT_INPUT_PLACEHOLDER
      }

      if (ctrl.question.texts.length > 1) {
        placeholder = index + 1 + '. ' + placeholder
      }

      return placeholder
    }

    function shouldShowMinCharacterWarning(text) {
      return (
        ctrl.question.minCharacters > 0 &&
        !ctrl.question.textValidator &&
        (!text || text.length < ctrl.question.minCharacters)
      )
    }
  }
})()
